// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__IP9we","ratio":"styles_ratio__n8JmR","share":"styles_share__vpQNX"};